

/*function initSelects() {
    $('select').each(function () {
        $(this).select2({
            minimumResultsForSearch: Infinity,
            placeholder: function () {
                $(this).data('placeholder');
            }
        });
    });
    $('select.change-sort').select2({
        minimumResultsForSearch: Infinity,
        containerCssClass: "container-change-sort",
        placeholder: function () {
            $(this).data('placeholder');
        }
    });
}

function initFormValidation() {
    $('form').not('.no-fv')
    .on('init.field.fv', function(e, data) {
      var $parent = data.element.parents('.form-group'),
          $icon   = data.element.data('fv.icon'),
          $label  = $parent.find('label'),
          $isCheckboxMultiple = data.element.parents('.content-checkbox--multi').length == 1;

      // Place the icon right after the label
      if( $isCheckboxMultiple) {
        $icon.insertAfter($label);
      }
    }).formValidation({
        framework: 'bootstrap',
        icon: {
            valid: 'icon-check',
            invalid: 'icon-croix',
            validating: 'icon-check'
        },
        err: {
            container: 'tooltip'
        },
        locale: 'fr_FR'
    }).on('err.field.fv', function (e, data) {
        // Get the tooltip
        var $icon = data.element.data('fv.icon'),
            title = $icon.data('bs.tooltip').getTitle();

        // Destroy the old tooltip and create a new one positioned to the right
        $icon.tooltip('destroy').tooltip({
            html: true,
            placement: 'bottom',
            title: title
        });
    });

    // fixme problème validation pickadate

    $('form[name=app_hr_application]').formValidation({
        framework: 'bootstrap',
        icon: {
            valid: 'icon-check',
            invalid: 'icon-error',
            validating: 'icon-check'
        },
        err: {
            container: 'tooltip'
        },
        excluded: ':disabled',
        locale: 'fr_FR',
        fields: {
            birthdate: {
                validators: {
                    notEmpty: {
                        message: 'The date of birth is required'
                    },
                    date: {
                        format: 'dd/mm/yyyy',
                        message: 'The date of birth is not a valid date'
                    }
                }
            }
        }
    });
}


function initTooltips() {
    $('[data-toggle="tooltip"]').tooltip();
}
*/

export default function common() {
    /*$('.btn-to-top').click(function(){
        $('html, body').animate({scrollTop : 0},800);
        return false;
    });*/

    /*$('a.btn-anchor').on('click', function (e) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        if (window.matchMedia('(min-width: 992px)').matches) {
            $('html, body').animate({
                scrollTop: target.offset().top -100
            }, 650);
        } else {
            $('html, body').animate({
                scrollTop: target.offset().top -60
            }, 650);
        }
         return false;
      }
   });*/

    // ajout classe img-responsive pour les images du contenu principal
    $(".rte-content img").addClass("img-fluid");

    // ajout classes img issues du rte en fonction de leur positionnement
    $(".rte-content img").each(function () {
        if ($(this).css("float") === "left") {
            $(this).addClass("alignLeft");
        }
        if ($(this).css("float") === "right") {
            $(this).addClass("alignRight");
        }
    });

    // ajout wrapper table-responsive pour les table du contenu principal
    $(".rte-content table").wrap("<div class='table-responsive'></div>");

    $('iframe[src*="youtube.com"]').wrap('<div class="youtubeWrapper" />');

    /******************************/

    /*$('.item-vehicle figure picture, .item-vehicle .item-vehicle__content__details, .item-vehicle .item-vehicle__content__version, ' +
        '.item-vehicle .item-vehicle__content__infos-price__price').on('click', function (e) {

        var link = $(this).parent().parent().find('.item-vehicle__content__title a').attr('href');
        window.location = link;
    })*/
};


// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/common/common.js